/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type UtxSecuritiesGetSecuritiesTransferType = typeof UtxSecuritiesGetSecuritiesTransferType[keyof typeof UtxSecuritiesGetSecuritiesTransferType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UtxSecuritiesGetSecuritiesTransferType = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
  NONE: 'NONE',
} as const;
